export const editableContent = {
  /* --------------------------- EVENT / IMPORTANT DATES --------------------------- */
  event: {
    slug: "social-run-for-spain",
    dateIso: "2026-09-06",
    time: "15:00",
    city: "Copenhagen",
    location: "Fælledparken",
    finishArea: "Dansepladsen",
    distance: "5 km",
    priceFrom: 50,
    monthLong: {
      es: "6 de septiembre de 2026",
      en: "6 September 2026",
      da: "6. september 2026",
    },
    importantDates: {
      title: {
        es: "Fechas importantes",
        en: "Important dates",
        da: "Vigtige datoer",
      },
      items: [
        {
          label: {
            es: "Inscripciones abiertas",
            en: "Registration opens",
            da: "Tilmeldinger åbner",
          },
          value: "1 de junio de 2026",
        },
        {
          label: {
            es: "Último día para inscribirse",
            en: "Last day to register",
            da: "Sidste dag til tilmelding",
          },
          value: "31 de agosto de 2026",
        },
        {
          label: {
            es: "Evento",
            en: "Event",
            da: "Begivenhed",
          },
          value: "6 de septiembre de 2026",
        },
      ],
    },
  },

  /* --------------------------- HOME SECTION CONTENT ------------------------------ */
  home: {
    hero: {
      eyebrow: {
        es: "DESDE DINAMARCA, CON SOLIDARIDAD",
        en: "FROM DENMARK, WITH SOLIDARITY",
        da: "FRA DANMARK MED SOLIDARITET",
      },
      title: {
        es: "Cuando España nos necesita, respondemos juntos.",
        en: "When Spain needs us, we respond together.",
        da: "Når Spanien har brug for os, svarer vi sammen.",
      },
      sub: {
        es: "Tu participación ayuda a las comunidades afectadas por los incendios forestales en España.",
        en: "Your participation helps communities affected by wildfires in Spain.",
        da: "Din deltagelse hjælper lokalsamfund, der er ramt af skovbrande i Spanien.",
      },
    },
    eventBar: [
      { key: "date", text: { es: "Domingo 6 de septiembre", en: "Sunday 6 September", da: "Søndag 6. september" } },
      { key: "place", text: { es: "Fælledparken", en: "Fælledparken", da: "Fælledparken" } },
      { key: "distance", text: { es: "5 km", en: "5 km", da: "5 km" } },
      { key: "music", text: { es: "Música en directo", en: "Live music", da: "Live musik" } },
      { key: "food", text: { es: "Gastronomía española", en: "Spanish food", da: "Spansk mad" } },
      { key: "charity", text: { es: "Evento benéfico", en: "Charity event", da: "Velgørenhedsbegivenhed" } },
    ],
  },

  /* --------------------------- IMAGE ASSETS ---------------------------------
   * All images live in /app/frontend/public/images/.
   * Replace any file inside that folder to swap it site-wide — no code changes.
   */
  images: {
    logo: "/images/logo.svg",
    planningMeeting: "/images/story-meeting.webp",
    volunteersHug: "/images/wildfires.png",
    churchEvent: "/images/community-event.webp",
    volunteersStage: "/images/jerseys-display.webp",
    paella: "/images/paella.jpg",
    danamark: "/images/danamark-team.jpg",
    volunteers: "/images/paella.jpg",
    wildfires: "/images/spain-wildfires.jpg",
    volunteersStory: "/images/paella.jpg",
    truck: "/images/truck.webp",
    eventHall: "/images/jerseys.jpg",
    jerseys: "/images/jerseys-display.webp",
  },

  /* ------------------------ SECTION / SESSION IMAGES ------------------------ */
  sectionImages: {
    home: {
      name: "Home",
      image: "/images/community-event.webp",
      alt: {
        es: "Evento comunitario en Copenhague",
        en: "Community event in Copenhagen",
        da: "Fællesskab i København",
      },
    },
    socialRun: {
      name: "Social Run",
      image: "/images/runners.jpg",
      alt: {
        es: "Corredores solidarios en un evento benéfico",
        en: "Charity runners on a connection event",
        da: "Løbere ved et velgørenhedsevent",
      },
    },
    projectsSpain: {
      name: "Projects in Spain",
      image: "/images/valencia-support.jpg",
      alt: {
        es: "Proyecto solidario en Valencia",
        en: "Support project in Valencia",
        da: "Støtteprojekt i Valencia",
      },
    },
    mission: {
      name: "Our Story",
      image: "/images/story-meeting.webp",
      alt: {
        es: "Los inicios de DANAmark en Copenhague",
        en: "The beginnings of DANAmark in Copenhagen",
        da: "Begyndelsen af DANAmark i København",
      },
    },
  },

  donation: {
    copy: {
      headline: {
        es: "Tu donación llega — directamente.",
        en: "Your donation arrives — directly.",
        da: "Din donation når frem — direkte.",
      },
      sub: {
        es: "Sin intermediarios. El apoyo llega a las personas que lo necesitan.",
        en: "No intermediaries. Support reaches the people who need it.",
        da: "Uden mellemled. Støtte når frem til dem, der har brug for det.",
      },
    },
    presets: [
      { amount: 150, impact: { es: "1 comida para una familia", en: "1 meal for a family", da: "1 måltid til en familie" } },
      { amount: 500, impact: { es: "1 semana de apoyo escolar", en: "1 week of school support", da: "1 uge med skolehjælp" } },
      { amount: 1500, impact: { es: "1 mes de apoyo", en: "1 month of support", da: "1 måned med støtte" } },
      { amount: 5000, impact: { es: "1 hogar reconstruido", en: "1 home rebuilt", da: "1 hjem genopbygget" } },
    ],
    trustItems: [
      { kind: "lock", label: { es: "Pago seguro", en: "Secure payment", da: "Sikker betaling" } },
      { kind: "shield", label: { es: "Asociación registrada", en: "Registered association", da: "Registreret forening" } },
    ],
    cvr: "45188981",
  },
  registration: {
    tiers: [
      {
        key: "participation",
        price: 50,
        label: { es: "Solo participación", en: "Participation only", da: "Kun deltagelse" },
        description: { es: "Entrada individual", en: "Individual entry", da: "Individuel billet" },
      },
      {
        key: "shirt",
        price: 150,
        label: { es: "Solo camiseta", en: "Shirt only", da: "Kun T-shirt" },
        description: { es: "Camiseta solidaria", en: "Connection shirt", da: "Solidaritets T-shirt" },
      },
      {
        key: "participation_shirt",
        price: 200,
        label: { es: "Participación + camiseta", en: "Participation + shirt", da: "Deltagelse + T-shirt" },
        description: { es: "Entrada individual con camiseta", en: "Individual entry with shirt", da: "Individuel billet med T-shirt" },
      },
    ],
  },

  /* --------------------------- MISSION / MANIFEST SECTION ------------------------- */
  manifest: {
    kicker: {
      es: "Nuestro manifiesto",
      en: "Our manifest",
      da: "Vores manifest",
    },
    headline: {
      es: "Creemos en el trabajo silencioso.",
      en: "We believe in the quiet work.",
      da: "Vi tror på det stille arbejde.",
    },
    body: {
      es: "No somos una institución. No somos una fundación con edificio de mármol ni una ONG con logo en cada puerta. Somos una asociación de personas — daneses, españoles y todos los demás — que hemos decidido que la conexión es una acción, no un titular.",
      en: "We are not an institution. We are neither a foundation with a marble building nor an NGO with a logo on every door. We are an association of people — Danes, Spaniards, and everyone in between — who have decided that connection is an action, not a headline.",
      da: "Vi er ikke en institution. Vi er hverken en stiftelse med marmorbygning eller en NGO med logo på hver dør. Vi er en forening af mennesker — danskere, spanierne og alle imellem — der har besluttet, at fællesskab er en handling, ikke en overskrift.",
    },
    pillars: [
      {
        title: {
          es: "Deporte",
          en: "Sport",
          da: "Sport",
        },
        description: {
          es: "Construimos puentes a través del movimiento, apoyando la energía colectiva de correr y compartir.",
          en: "We build bridges through movement, supporting the collective energy of running and sharing.",
          da: "Vi bygger broer gennem bevægelse og understøtter den fælles energi i at løbe og dele.",
        },
      },
      {
        title: {
          es: "Cultura",
          en: "Culture",
          da: "Kultur",
        },
        description: {
          es: "La cultura es el lenguaje que une a comunidades y recuerda por qué estamos juntos.",
          en: "Culture is the language that unites communities and reminds us why we are together.",
          da: "Kultur er det sprog, der forener fællesskaber og minder os om, hvorfor vi er sammen.",
        },
      },
      {
        title: {
          es: "Comunidad",
          en: "Community",
          da: "Fællesskab",
        },
        description: {
          es: "La conexión es un trabajo compartido; juntos hacemos más que sumas individuales.",
          en: "Connection is shared work; together we achieve more than individual sums.",
          da: "Fællesskab er delt arbejde; sammen opnår vi mere end enkelte dele.",
        },
      },
    ],
    foundersNote: {
      quote: {
        es: "Comenzamos DANAmark no porque tuviéramos todas las respuestas, sino porque teníamos tiempo, amigos y una carrera por delante. Eso fue suficiente para empezar.",
        en: "We started DANAmark not because we had all the answers, but because we had time, friends and a run ahead of us. That was enough to begin.",
        da: "Vi startede DANAmark ikke fordi vi havde svarene, men fordi vi havde tid, venner og et løb foran os. Det var nok til at begynde.",
      },
      author: {
        es: "— Amalie & Mikkel, Copenhague, 2025",
        en: "— Amalie & Mikkel, Copenhagen, 2025",
        da: "— Amalie & Mikkel, København, 2025",
      },
    },
  },

  /* --------------------------- ABOUT / WHO WE ARE ------------------------------ */
  about: {
    kicker: {
      es: "Sobre DANAmark Solidaridad",
      en: "About DANAmark",
      da: "Om DANAmark",
    },
    headline: {
      es: "Las personas detrás.",
      en: "The people behind.",
      da: "Menneskene bag.",
    },
    body: {
      es: "DANAmark Conexión nace de una comunidad de voluntarios daneses y españoles que decidieron transformar el apoyo urgente en un movimiento duradero.",
      en: "DANAmark grew from a community of Danish and Spanish volunteers who decided to turn urgent support into a lasting movement.",
      da: "DANAmark voksede ud af et fællesskab af danske og spanske frivillige, der besluttede at gøre akut støtte til en varig bevægelse.",
    },
    leadershipTitle: {
      es: "Dirección y consejo",
      en: "Leadership & board",
      da: "Ledelse & bestyrelse",
    },
    leadershipBody: {
      es: "DANAmark es una asociación danesa registrada bajo CVR 45188981 y publica sus cuentas anuales abiertamente.",
      en: "DANAmark is a Danish association registered under CVR 45188981 and publishes its annual accounts openly.",
      da: "DANAmark er en dansk forening registreret under CVR 45188981 og offentliggør årsregnskabet åbent.",
    },
    contactTitle: {
      es: "Contacto",
      en: "Contact",
      da: "Kontakt",
    },
    contactBody: {
      es: "danamarksolidaritet@gmail.com\nCopenhagen, Denmark",
      en: "danamarksolidaritet@gmail.com\nCopenhagen, Denmark",
      da: "danamarksolidaritet@gmail.com\nCopenhagen, Denmark",
    },
  },

  /* --------------------------- IMPACT / EFFECT ------------------------------ */
  impact: {
    kicker: {
      es: "Impacto",
      en: "Impact",
      da: "Effekt",
    },
    headline: {
      es: "Números abiertos.",
      en: "Open numbers.",
      da: "Åbne tal.",
    },
    sub: {
      es: "Qué recaudamos. Dónde se invierte. Actualizamos mensualmente.",
      en: "What we raise. Where it goes. Updated monthly.",
      da: "Hvad vi indsamler. Hvor det går hen. Opdateres månedligt.",
    },
    statsTitle: {
      es: "Indicadores editoriales",
      en: "Editorial metrics",
      da: "Redaktionelle nøgletal",
    },
    projectsTitle: {
      es: "Proyectos en España",
      en: "Projects in Spain",
      da: "Projekter i Spanien",
    },
  },

  /* --------------------------- GET INVOLVED / PARTICIPATE ------------------------ */
  getInvolved: {
    kicker: {
      es: "Participa",
      en: "Get involved",
      da: "Deltag",
    },
    headline: {
      es: "Muchas formas de estar con nosotros.",
      en: "Many ways to join.",
      da: "Mange måder at være med.",
    },
    items: [
      {
        title: { es: "Corre con nosotros", en: "Run with us", da: "Løb med" },
        description: { es: "Regístrate para Social Run for Spain — individual, equipo o familia.", en: "Register for Social Run for Spain — individual, team or family.", da: "Tilmeld dig Social Run for Spain — individuelt, som hold eller familie." },
        to: "/events",
      },
      {
        title: { es: "Dona", en: "Donate", da: "Donér" },
        description: { es: "Tu aportación llega directamente a las familias que apoyamos.", en: "Your gift reaches the families we support directly.", da: "Din donation når direkte til de familier, vi støtter." },
        to: "/donate",
      },
      {
        title: { es: "Hazte partner", en: "Become a partner", da: "Bliv partner" },
        description: { es: "Para empresas y fundaciones. Consulta nuestros paquetes de colaboración.", en: "For businesses and foundations. See our partner packages.", da: "For virksomheder og fonde. Se vores partnerpakker." },
        to: "/partnership",
      },
      {
        title: { es: "Voluntariado", en: "Volunteer", da: "Frivillig" },
        description: { es: "Únete como voluntario: trabajo de campo, traducción, logística o comunicación.", en: "Join as a volunteer: field work, translation, logistics or stories.", da: "Meld dig som frivillig — feltarbejde, oversættelse, logistik eller historier." },
        to: "/volunteer",
      },
    ],
  },

  /* --------------------------- PARTNERSHIP / SPONSORSHIP ------------------------- */
  partnership: {
    kicker: {
      es: "Partnership",
      en: "Partnership",
      da: "Partnerskab",
    },
    headline: {
      es: "Construye con nosotros.",
      en: "Build with us.",
      da: "Byg med os.",
    },
    form: {
      name: { es: "Nombre", en: "Name", da: "Navn" },
      email: { es: "Email", en: "Email", da: "Email" },
      organization: { es: "Organización", en: "Organization", da: "Organisation" },
      message: { es: "Cuéntanos sobre ti", en: "Tell us about you", da: "Fortæl os om dig" },
      button: { es: "Enviar", en: "Send", da: "Send" },
    },
    thankYou: {
      title: {
        es: "Gracias por tu interés.",
        en: "Thank you for your interest.",
        da: "Tak for din interesse.",
      },
      body: {
        es: "Pronto nos pondremos en contacto contigo para explorar cómo colaborar.",
        en: "We will contact you soon to explore how we can collaborate.",
        da: "Vi kontakter dig snart for at udforske, hvordan vi kan samarbejde.",
      },
    },
  },

  /* --------------------------- LEGAL / INFORMATION ----------------------------- */
  legal: {
    intro: {
      es: "Esta página muestra la información legal de DANAmark Conexión según la normativa vigente.",
      en: "This page provides DANAmark legal information in accordance with current regulations.",
      da: "Denne side viser juridisk information om DANAmark i henhold til gældende regler.",
    },
    contact: {
      es: "Contacto: danamarksolidaritet@gmail.com · CVR 45188981",
      en: "Contact: danamarksolidaritet@gmail.com · CVR 45188981",
      da: "Kontakt: danamarksolidaritet@gmail.com · CVR 45188981",
    },
  },
};
